import React from 'react';
import './Loading.scss';

const Loading = () => {
  return (
    <div className="LoadingGB">
      <svg
        id="skeletonCurvasV2"
        imageRendering="auto"
        baseProfile="basic"
        version="1.1"
        x="0px"
        y="0px"
        width={1920}
        height={160}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <g id="S.__C3.__ADmbolo-1" overflow="visible">
            <path
              fill="#FFF"
              stroke="none"
              d="M155.2 51.25Q0 102.55 0 175 0 247.5 155.2 298.7 310.45 350 530 350 749.6 350 904.75 298.7 1060 247.5 1060 175 1060 102.55 904.75 51.25 749.6 0 530 0 310.45 0 155.2 51.25Z"
            />
          </g>
          <g id="S.__C3.__ADmbolo-2" overflow="visible">
            <path
              fill="url(#Gradient_2)"
              stroke="none"
              d="M480 160L480 0 0 0 0 160 480 160Z"
            />
          </g>
          <g id="sombra" overflow="visible">
            <path
              fill="url(#Gradient_1)"
              stroke="none"
              d="M945.95 283.5Q1108.3 234.85 1108.3 166.1 1108.3 97.3 945.95 48.65 783.6 .05 554.15 .05 324.7 .05 162.35 48.65 0 97.3 0 166.1 0 234.85 162.35 283.5 324.7 332.15 554.15 332.15 783.6 332.15 945.95 283.5Z"
            />
          </g>
          <linearGradient
            id="Gradient_1"
            gradientUnits="userSpaceOnUse"
            x1="554.15"
            y1="332.087"
            x2="554.15"
            y2=".012"
            spreadMethod="pad"
          >
            <stop offset="0%" stopColor="#808080" />
            <stop offset="100%" stopColor="#FFF" />
          </linearGradient>
          <linearGradient
            id="Gradient_2"
            gradientUnits="userSpaceOnUse"
            x1={0}
            y1={80}
            x2={480}
            y2={80}
            spreadMethod="pad"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity={0} />
            <stop offset="50.196%" stopColor="#FFF" />
            <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
          </linearGradient>
        </defs>
        <g id="Escena-1" overflow="visible">
          <use xlinkHref="#sombra" transform="matrix(1.036 0 0 1 -135.95 8)" />
          <use
            xlinkHref="#sombra"
            transform="matrix(-1.04 0 0 -1 2048.5 156)"
          />
          <g
            id="S.__C3.__ADmbolo-3"
            transform="matrix(1 0 0 1.201 -42 -273.85)"
          >
            <path
              id="Layer3_0_1_STROKES"
              stroke="#CCC"
              strokeWidth={1}
              strokeLinejoin="round"
              strokeLinecap="round"
              fill="none"
              d="M1948 175Q1948 247.5 1792.75 298.7 1637.6 350 1418 350 1198.45 350 1043.2 298.7 888 247.5 888 175 888 102.55 1043.2 51.25 1198.45 0 1418 0 1637.6 0 1792.75 51.25 1948 102.55 1948 175ZM1060 421Q1060 493.5 904.75 544.7 749.6 596 530 596 310.45 596 155.2 544.7 0 493.5 0 421 0 348.55 155.2 297.25 310.45 246 530 246 749.6 246 904.75 297.25 1060 348.55 1060 421Z"
            />
          </g>
          <use
            xlinkHref="#S.__C3.__ADmbolo-2"
            transform="matrix(1.884 0 0 1 472.15 0)"
          />
          <use xlinkHref="#S.__C3.__ADmbolo-2" transform="translate(-480 0)">
            <animateTransform
              attributeName="transform"
              additive="replace"
              type="translate"
              repeatCount="indefinite"
              dur="2s"
              keyTimes="0;.983;1"
              values="-480,0;1920,0;1920,0"
            />
          </use>
          <use xlinkHref="#S.__C3.__ADmbolo-1" transform="translate(-14 32)" />
          <use
            xlinkHref="#S.__C3.__ADmbolo-1"
            transform="translate(874 -214)"
          />
          <use xlinkHref="#S.__C3.__ADmbolo-1" transform="translate(-14 32)" />
          <use
            xlinkHref="#S.__C3.__ADmbolo-1"
            transform="translate(874 -214)"
          />
        </g>
      </svg>
    </div>
  );
};

export default Loading;
